import React, {Component} from "react";
import Dotdotdot from "react-dotdotdot";
import "./PlayerEndOverlay.scss";
import AssetThumbnail from "../AssetThumbnail/AssetThumbnail";
import common from "../../utils/common";
import PlayIcon from "../../ui/PlayIcon/PlayIcon";

const RoundedPlayIcon = () => <span className="rounded-play-icon">
        <PlayIcon />
    </span>;

class PlayerEndOverlay extends Component {
    render() {
        const {asset, replay, nextAsset} = this.props;
        return <div className={"autonext-controls animate"}>
            <div className={"controls-container"}>
                <div className={"left-controls"}>
                    <div className={"left-controls-replay"}>
                        Replay?
                    </div>
                    <div onClick={replay} className={"left-controls-asset-to-replay"}>
                        <div className={"asset-thumbnail"}>
                            <AssetThumbnail thumbnailUrl={common.getThumbnail(asset)} alt={asset.title}
                                            lazyLoadingThumbnails={false}
                                            isPhoto={asset.entityType == 7}/>
                            <div className={"replay-button"}>
                                <svg width="32px" height="32px" viewBox="0 0 24 24">
                                    <path fill="#ffffff"
                                          d="M12,5V1L7,6L12,11V7A6,6 0 0,1 18,13A6,6 0 0,1 12,19A6,6 0 0,1 6,13H4A8,8 0 0,0 12,21A8,8 0 0,0 20,13A8,8 0 0,0 12,5Z"/>
                                </svg>
                            </div>
                        </div>
                        <div className={"asset-title"}>
                            <Dotdotdot clamp={2}>
                                {asset.title}
                            </Dotdotdot>
                        </div>
                    </div>
                </div>
                <div className={"right-controls"}>
                    <div className={"right-controls-next"}>
                        Up Next
                    </div>
                    <a href={common.generateAssetUrlFrom(nextAsset)} className={"right-controls-asset-to-play"}>
                        <div className={"asset-thumbnail"}>
                            <AssetThumbnail thumbnailUrl={common.getThumbnail(nextAsset)} alt={nextAsset.title}
                                            lazyLoadingThumbnails={false}
                                            isPhoto={(nextAsset.entityType == 7)}/>
                            { (nextAsset.entityType != 7) && <RoundedPlayIcon/>}
                        </div>
                        <div className={"asset-title"}>
                            <Dotdotdot clamp={2}>
                                {nextAsset.title}
                            </Dotdotdot>
                        </div>
                    </a>
                </div>
                <div className={"mobile-repeat-button"}>
                    <div onClick={replay} className={"replay-button"}>
                        <svg width="24px" height="24px" viewBox="0 0 24 24">
                            <path fill="#ffffff"
                                  d="M12,5V1L7,6L12,11V7A6,6 0 0,1 18,13A6,6 0 0,1 12,19A6,6 0 0,1 6,13H4A8,8 0 0,0 12,21A8,8 0 0,0 20,13A8,8 0 0,0 12,5Z"/>
                        </svg>
                    </div>
                </div>
            </div>

        </div>
    }
}

export default PlayerEndOverlay;